export default __webpack_public_path__ + "static/media/Edison.419d5612.webp";